import { cfetch } from '@confluence/network';
import type { NetworkError } from '@confluence/network';
import { getMonitoringClient } from '@confluence/monitoring/entry-points/getMonitoringClient.ts';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';

export const downloadUnsplashPhoto = async (downloadLink: string): Promise<Response> => {
	return cfetch(`/wiki/rest/internals/1.0/unsplash/download`, {
		method: 'POST',
		body: JSON.stringify({
			downloadLink,
		}),
		headers: {
			'Content-Type': 'application/json',
		},
	}).catch((error: NetworkError) => {
		getMonitoringClient().submitError(error, {
			attribution: Attribution.PAGE_EXPERIENCES,
		});

		throw error;
	});
};
